module.exports = __webpack_public_path__ + "static/img/bc-mps.0af2407.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/bc/bc-mps.png
// module id = oCyu
// module chunks = 0